import { render } from "./CalibrationDeviation.vue?vue&type=template&id=01bc2512&scoped=true"
import script from "./CalibrationDeviation.vue?vue&type=script&lang=js"
export * from "./CalibrationDeviation.vue?vue&type=script&lang=js"

import "./CalibrationDeviation.vue?vue&type=style&index=0&id=01bc2512&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc2512"]])

export default __exports__